<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('payment Methods')"
          :description="$t('from Here You Can Control The Payment Methods')"
        />
        <indexTable
          :searchText="$t('Search For A Payment Method')"
          :emptyTableText="$t('there Are No Payment Methods')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="
            $checkRole('sales_payments_add') ||
            $checkRole('purchase_payments_add') ||
            $checkRole('expenses_add')
              ? 1
              : 0
          "
          :cloumns="[
            {
              column: 'name',
              title: $t('Payment method'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Actions'),
              type: 'options',
              options: [
                {
                  name: 'edit',
                  role:
                    $user.admin ||
                    $checkRole('sales_payments_edit') ||
                    $checkRole('purchase_payments_edit') ||
                    $checkRole('expenses_edit')
                },
                {
                  name: 'delete',
                  role:
                    $user.admin ||
                    $checkRole('sales_payments_delete') ||
                    $checkRole('purchase_payments_delete') ||
                    $checkRole('expenses_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/paymentMethods'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
